module.exports = __webpack_public_path__ + "static/media/shamaim_logo.f1161edf.png";